import React from "react";
import * as styles from "./styles/HomeAbout.css";

const HomeAbout = () => {
	return (
		<section className={styles.sectionCloser}>
			<div className={styles.container}>
				<div className={styles.content}>
					<h2>More from Art of Problem Solving</h2>

					<p className={styles.textBlue}>
						Art of Problem Solving offers two other multifaceted programs. AoPS
						Online trains secondary students in advanced, upper-level math and
						science. And AoPS Academy brings our methodology to small, in-person
						classes at local campuses.
					</p>

					<p className={styles.textBlue}>
						Through our three programs, AoPS offers the most comprehensive
						honors math pathway in the world.
					</p>

					<p className={styles.textBlue}>
						<a
							href="https://artofproblemsolving.com/resources/program-comparison"
							target="_blank"
							className={styles.link}
							rel="noopener noreferrer"
						>
							Compare program offerings here.
						</a>
					</p>

					<img
						src="/assets/images/logos/aops-full-logo.svg"
						loading="lazy"
						width="316"
						alt="art of problem solving logo"
						className={styles.logo}
					/>
				</div>
			</div>
		</section>
	);
};

export default HomeAbout;
